export class FilterRealCompetition {
    ctrl_page: number;
    ctrl_season: string;
    ctrl_id: number;
    ctrl_description: string;

}